import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  ImportModelResponse,
  ModelImportValues
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params: ModelImportValues
  onSuccess?: (response: ImportModelResponse) => void
  children?: () => ReactElement
}

const ImportModelerModelRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/models`

  const { requestParams } = useGetParamsWithSpaceId<ModelImportValues>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default ImportModelerModelRequest
